import React, { FC, useEffect, useMemo, useState } from "react";
import { KeyboardAvoidingView, Platform, View, useWindowDimensions, ScrollView, Pressable, BackHandler } from "react-native";
import { useFormik } from "formik";
import * as Yup from 'yup'
import moment from "moment";
import Popover from "react-native-popover-view/dist/Popover";
import { useIsFocused } from "@react-navigation/native";

import { config } from "../../../shared/environment";
import { getScreenPermission, useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { appColors, appFonts, fontSize } from "../../../themes/appTheme";
import CommonHeader from "../../../shared/commonComponents/commonHeader";
import { checkDuplicatesData, getOnePayxDiscount, getAllPayxPropertyData, addPayXDiscount, updatePayXDiscount } from "../../../redux/slices/payXGetFreeSlice";
import { getDiscountAppliesTo } from "../../../redux/slices/buyXgetYDiscountSlice";
import CommonDialogBox from "../../../shared/commonComponents/commonDialogBox";
import { PayXGetFreeStyle } from "../../../themes/components/discounts/payXGetFreeStyle";
import { CustomerGroupVal, CustomerVal, DiscountDetails, DropDownData, PropertyValueData, PropertyValues, RoleBasedVal, confirmtionMessageProps, dropDownValues, formValues } from "./payXGetFreeModule";
import { ZenText, ZenButton, ZenDateTimePicker, ZenDropdown, ZenIcon, ZenInput, ZenLoader, ZenToast, ZenToolTip, ZenCheckBox } from "zen-core-elements";
import { useAppNavigation, useAppRoute } from "../../../types/@react-navigation/navigation";
import { addEditBuyXgetYDiscountStyle } from "../../../themes/components/discounts/addEditBuyXgetYDiscountStyle";
import { useTheme } from "@rneui/themed";
import { shallowEqual } from "react-redux";

const currentDate = new Date()

const AddEditPayXGetFree: FC = () => {
    const { isWrite } = useAppSelector(getScreenPermission("PayXGetFreeStack"), shallowEqual);

    //variable to store the navigation from useNavigation hook
    const navigation = useAppNavigation()
    //variable to store the screen width
    const { width } = useWindowDimensions()
    //variable to store the loading status
    const [load, setLoad] = useState<boolean>(true)
    //variable to open/close dropdown
    const [dropdownOpen, setDropdownOpen] = useState<boolean>(false)
    //variable to store the product items
    const [freeProducts, setFreeProducts] = useState<any>([])
    //variable used to open/close date picker
    const [showDate, setShowDate] = useState<boolean>(false);
    //variable to set hold the current date
    const [date, setDate] = useState(new Date());
    //Variable to set startDate
    const [startDateSelected, setStartDateSelected] = useState<boolean>(false);
    // Variable which is used to open/close eligibility dropdown picker 
    const [eligibilityOpen, setEligibilityOpen] = useState<boolean>(false)
    //variable to store the customer eligibility 
    const [customerEligibility, setCustomerEligibility] = useState<any>([])
    //variable to store the isFocused state from useIsFocused hook
    const isFocused = useIsFocused()
    //variable to display product warning popover
    const [showProductPopover, setShowProductPopover] = useState<boolean>(false)
    //variable to store the selected product mapping
    const [selectedProductMapping, setSelectedProductMapping] = useState<string[]>([])
    //variable to store the customer dropdown values
    const [customer, setCustomer] = useState<any>([])
    //variable to store customer group dropdown values
    const [customerGroup, setCustomerGroup] = useState<any>([])
    //variable to store multiple customers
    const [multipleCustomer, setMultipleCustomer] = useState<string[]>([])
    // Variable which is used to open/close customergroup picker
    const [customerGroupOpen, setCustomerGroupOpen] = useState<boolean>(false)
    //Variable that holds the customer eligibility items
    const customerEligibilityTypeObj = { ForAll: 'FOR_ALL', CustomerGroup: 'CUSTOMER_GROUP', RoleBased: 'ROLE_BASED', Customers: 'CUSTOMERS', }
    //variable to store role dropdown values
    const [role, setRole] = useState<any>([])
    //Variable to store the multiple roles selected
    const [multipleRole, setMultipleRole] = useState<string[]>([])
    // Variable which is used to open/close role picker
    const [roleOpen, setRoleOpen] = useState<boolean>(false)
    // Variable which is used to open/close customer picker
    const [openCustomer, setOpenCustomer] = useState<boolean>(false)
    //variable to store multiple customer group 
    const [multipleCustomerGroup, setMultipleCustomerGroup] = useState<string[]>([])
    //variable which holds route params
    const { params } = useAppRoute("AddEditPayXGetFree")
    const { theme } = useTheme()
    //variable to check duplicate title
    const [alreadyExist, setAlreadyExist] = useState<boolean>(false)
    //variable to store multiple free products
    const [multipleFreeProducts, setMultipleFreeProducts] = useState<number[]>([])
    //variable to store the confirmation message
    const [confirmMessage, setConfirmMessage] = useState<confirmtionMessageProps | null>(null)
    //variable to store the expired popover confirmation message
    const [expiredMessage, setExpiredMessage] = useState<confirmtionMessageProps | null>(null)
    //variable to store the popover expired status
    const [discountExpired, setDiscountExpired] = useState<boolean>(false)
    //variable to display expired discount popover
    const [expiredPopover, setExpiredPopover] = useState<boolean>(false)
    //variable to store the noProducts data
    const [noProducts, setNoProducts] = useState<boolean>(false)
    //variable to open/close confirmation popover
    const [dirtyPopover, setDirtyPopover] = useState<boolean>(false)
    //variable to dispatch actions
    const dispatch = useAppDispatch()
    //variable to get current user
    const currentUser = useAppSelector(state => state.common.currentUser?.value)

    const { getOnePosDiscount: getOnePosDiscountState, getAllProperties: getAllPropertiesState } = useAppSelector(state => state.payXDiscount)
    const { roleData, customerGroupData, customerData, productData } = useAppSelector(state => state.buyXgetYDiscount)

    //variable to store the  confirmation dialog props
    const dialogProps = {
        content: "Sorry, some product(s) are removed from their respective pages, so they are not loaded in the choose free product",
        icon: { name: 'alert-outline', color: appColors.primary, type: 'material-community' }, button: [{ id: 1, name: "okay" }]
    }
    //variable to store the  confirmation dialog props
    const expiredDialogProps = {
        content: 'The discount has expired. Kindly change the endDate to edit the discount',
        icon: { name: 'run', color: appColors.primary, type: 'material-community' }, button: [{ id: 1, name: "okay" }]
    }

    //formik validation schmea
    const validationScheme = Yup.object().shape({
        discountTitle: Yup.string().label('discountTitle').required('Discount Title is required').max(50, "Discount title shouldn't be exceed 50 characters")
            .test('Space checking', "Discount title should not be empty", (val) => {
                if (val.match(/^(?! ).*(?<! )$/))
                    return true
            }),
        desc: Yup.string().max(250, ' Description should not exceed 250 characters.'),
        usagelimits: Yup.number().label('usagelimits')
            .nullable()
            .min(1, 'Total usage limits should range from 1 to 1000.')
            .max(1000, 'Total usage limits should range from 1 to 1000.')
            .integer("Total usage limits accepts only whole numbers .")
            .typeError('Total usage limits accepts only numbers.'),
        usagelimitpercustomer: Yup.number()
            .label('Usage limit per customer')
            .when("usagelimits", (limit) => {
                if (limit[0]) {
                    return Yup.number()
                        .integer('Usage limits per customer accepts only whole numbers .')
                        .typeError('Usage limits per customer only accept numbers')
                        .min(1, "Usage limits per customer should starts from 1")
                        .max(1000, 'Usage limits per customer should not exceed 1000.')
                        .test('checking', 'Usage limits per customer should not exceed the total usage limit.', (val: any) => val < 1000 ? limit >= val : true)
                }
                else {
                    return Yup.number()
                        .integer('Usage limits per customer accepts only whole numbers .')
                        .typeError('Usage limits per customer only accept numbers')
                        .min(1, "Usage limits per customer should starts from 1")
                        .max(1000, "Usage limits per customer should not exceed 1000.")
                }
            }),
        purchaseAmount: Yup.number().label('purchaseAmount')
            .required('Purchase amount is required')
            .min(1, ' Purchase amount value starts from 1.')
            .max(1000000, 'Purchase amount should not exceed 1000000.')
            .typeError('Total usage limits accepts only numbers.')
            .test('Decimal point validation', 'Purchase amount value accepts up to two decimals only', (val) => {
                if (String(val).match(/^[0-9]+([.][0-9]{1,2})*$/))
                    return true
            }),
        startDate: Yup.date().label('startDate'),
        endDate: Yup.date()
            .when("startDate", (startDate) => {
                if (startDate[0]) {
                    return Yup.date().test("checkDate", 'End date is invalid', val => val ? moment(val).isAfter(startDate[0]) : true)
                }
                else {
                    return Yup.date()
                        .label('endDate')
                }
            }),
        customerEligibilityType: Yup.number(),
        customerGroupDiscountMapping: Yup.array()
            .label('customerGroupDiscountMapping')
            .when("customerEligibilityType", (type) => {
                if (customerEligibility?.find((i: dropDownValues) => i?.id === type[0])?.code === customerEligibilityTypeObj?.CustomerGroup) {
                    return Yup.array().required().min(1, 'Customer Eligibility is required')
                }
                else { return Yup.array().nullable() }
            }),
        customerDiscountMapping: Yup.array()
            .label('customerDiscountMapping')
            .when("customerEligibilityType", (type) => {
                if (customerEligibility?.find((i: dropDownValues) => i?.id === type[0])?.code === customerEligibilityTypeObj?.Customers) {
                    return Yup.array().required().min(1, 'Customer Eligibility is required')
                }
                else { return Yup.array().nullable() }
            }),
        roleDiscountMapping: Yup.array()
            .label('roleDiscountMapping')
            .when("customerEligibilityType", (type) => {
                if (customerEligibility?.find((i: dropDownValues) => i?.id === type[0])?.code === customerEligibilityTypeObj?.RoleBased) {
                    return Yup.array().required().min(1, 'Customer Eligibility is required')
                }
                else { return Yup.array() }
            })
    })

    const formik = useFormik({
        initialValues: {
            // isHidden: getOnePosDiscountState?.value?.discount?.isHidden != null ? getOnePosDiscountState?.value?.discount?.isHidden : null,
            discountTitle: params?.discountId ? getOnePosDiscountState?.value?.discount?.title! : '',
            desc: params?.discountId ? getOnePosDiscountState?.value?.discount?.description ? String(getOnePosDiscountState?.value?.discount?.description) : '' : '',
            isActive: params?.discountId ? getOnePosDiscountState?.value?.discount?.isActive! : true,
            usagelimits: params?.discountId ? getOnePosDiscountState?.value?.discount?.overallUsageLimit && parseFloat(getOnePosDiscountState?.value?.discount?.overallUsageLimit) > 0 ? String(parseFloat(getOnePosDiscountState?.value?.discount?.overallUsageLimit)) : '' : '',
            usagelimitpercustomer: params?.discountId ? getOnePosDiscountState?.value?.discount?.userBasedMaxUse && parseFloat(getOnePosDiscountState?.value?.discount?.userBasedMaxUse) > 0 ? String(parseFloat(getOnePosDiscountState?.value?.discount?.userBasedMaxUse)) : '' : '',
            purchaseAmount: params?.discountId ? getOnePosDiscountState?.value?.discount?.minValue && parseFloat(getOnePosDiscountState?.value?.discount?.minValue) > 0 ? String(parseFloat(getOnePosDiscountState?.value?.discount?.minValue)) : '' : '',
            startDate: params?.discountId ? (getOnePosDiscountState?.value?.discount?.startDate != undefined ? getOnePosDiscountState?.value?.discount?.startDate : '') : useMemo(() => new Date(), []),
            endDate: getOnePosDiscountState?.value?.discount?.endDate ? getOnePosDiscountState?.value?.discount?.endDate?.toString() : '',
            customerEligibilityType: params?.discountId ? getOnePosDiscountState?.value?.discount?.customerEligibilityType : customerEligibility?.find((i: dropDownValues) => i.code === customerEligibilityTypeObj?.ForAll)?.id,
            roleDiscountMapping: (params?.discountId ? getOnePosDiscountState?.value?.discount?.discountMappings?.roleDiscountMappings ? getOnePosDiscountState?.value?.discount?.discountMappings?.roleDiscountMappings : [] : []) as number[],
            customerGroupDiscountMapping: (params?.discountId ? getOnePosDiscountState?.value?.discount?.discountMappings?.customerGroupDiscountMappings ? getOnePosDiscountState?.value?.discount?.discountMappings?.customerGroupDiscountMappings : [] : []) as number[],
            customerDiscountMapping: (params?.discountId ? getOnePosDiscountState?.value?.discount?.discountMappings?.customerDiscountMappings ? getOnePosDiscountState?.value?.discount?.discountMappings?.customerDiscountMappings : [] : []) as number[],
            productMapping: (params?.discountId ? selectedProductMapping : []) as string[],
        },
        onSubmit: (values) => saveDiscount(values),
        enableReinitialize: true,
        validationSchema: validationScheme,
    })


    //UseEffect function which is used to perform backhandler operation
    useEffect(() => {
        BackHandler.addEventListener('hardwareBackPress', function () {
            if (formik?.dirty) {
                setDirtyPopover(true)
            }
            else {
                navigation.goBack()
            }
            return true
        })
    }, [formik?.dirty])

    //UseEffect which runs on page focus
    useEffect(() => {
        if (isFocused) {
            if (params?.discountId) {
                getPayXGetFreeDiscountDetails()
            } else {
                getAllProperties()
            }
        }
    }, [isFocused])

    //UseEffect to handle expired and warning popover
    useEffect(() => {
        if (noProducts) {
            setShowProductPopover(true);
            if (discountExpired) {
                setExpiredPopover(false);
            }
        } else {
            setShowProductPopover(false);
            if (discountExpired) {
                setExpiredPopover(true);
            }
        }
    }, [noProducts, discountExpired]);

    //UseEffect which gets triggered when customer eligibility value changes
    useEffect(() => {
        if (!params?.discountId) {
            const data = customerEligibility?.find((e: dropDownValues) => e?.label === 'For All')
            if (data) {
                formik.setFieldValue("customerEligibilityType", data?.id)
            }
        }
    }, [customerEligibility])

    //UseEffect to handle product warning popover
    useEffect(() => {
        if (showProductPopover && confirmMessage) {
            if (confirmMessage?.name == "okay") {
                setShowProductPopover(false);
            }
        }
    }, [confirmMessage])

    //UseEffect to handle discount expired popover
    useEffect(() => {
        if (expiredMessage && expiredPopover) {
            if (expiredMessage?.name == "okay") {
                setExpiredPopover(false);
            }
        }
    }, [expiredMessage])

    //UseEffect which gets triggered when customerEligibility dropdown value changes
    useEffect(() => {
        if (formik?.values?.customerEligibilityType != undefined) {
            const data = { isDiscount: true, isActive: true, issueCard: null }
            if (customerEligibility?.find((e: dropDownValues) => e?.id === formik?.values?.customerEligibilityType)?.code == "CUSTOMERS") {

                if (customerData?.value?.customers?.rows) {
                    const customerDropdownValues = customerData?.value?.customers?.rows?.map((value: CustomerVal) => ({ label: `${value?.user?.firstName} ${value?.user?.email ? " - " + value?.user?.email : ""}`, value: value?.customerId }));
                    setCustomer(customerDropdownValues)
                    if (formik?.values?.customerDiscountMapping?.length > 0) {
                        const selectedCustomerVal = customerDropdownValues?.filter((e: DropDownData) => formik?.values?.customerDiscountMapping?.includes(e?.value))
                        setMultipleCustomer(selectedCustomerVal.map((e: DropDownData) => e?.label))
                    }
                    formik?.setFieldTouched("roleDiscountMapping", false)
                    formik?.setFieldTouched("customerGroupDiscountMapping", false)
                    setRoleOpen(false);
                    setMultipleRole([]);
                    setCustomerGroupOpen(false);
                    setMultipleCustomerGroup([]);
                } else {
                    dispatch(getDiscountAppliesTo({ storeId: config?.storeId, url: '/customers/name', data })).unwrap().then((res: any) => {

                        if (res && res?.customers) {
                            const customerDropdownValues = res?.customers?.map((value: any) => ({ label: `${value?.name} ${value?.email ? " - " + value?.email : ""}`, value: value?.id }));
                            setCustomer(customerDropdownValues)
                            if (formik?.values?.customerDiscountMapping?.length > 0) {
                                const selectedCustomerVal = customerDropdownValues?.filter((e: DropDownData) => formik?.values?.customerDiscountMapping?.includes(e?.value))
                                setMultipleCustomer(selectedCustomerVal.map((e: DropDownData) => e?.label))
                            }
                            formik?.setFieldTouched("roleDiscountMapping", false)
                            formik?.setFieldTouched("customerGroupDiscountMapping", false)
                            setRoleOpen(false);
                            setMultipleRole([]);
                            setCustomerGroupOpen(false);
                            setMultipleCustomerGroup([]);
                        }
                    }).catch((err) => {
                        console.log("Error in get customers", err);
                    })
                }
            }
            if (customerEligibility?.find((e: dropDownValues) => e?.id === formik?.values?.customerEligibilityType)?.code == "CUSTOMER_GROUP") {
                if (customerGroupData?.value) {
                    const customerGrpDropdownValues = customerGroupData?.value?.map((e: any) => ({ label: e?.groupName, value: e?.id }));
                    setCustomerGroup(customerGrpDropdownValues)
                    if (formik?.values?.customerGroupDiscountMapping?.length > 0) {
                        const selectedGrpVal = customerGrpDropdownValues?.filter((e: DropDownData) => formik?.values?.customerGroupDiscountMapping?.includes(e?.value))
                        setMultipleCustomerGroup(selectedGrpVal.map((e: DropDownData) => e?.label))
                    }
                    formik?.setFieldTouched("roleDiscountMapping", false)
                    formik?.setFieldTouched("customerDiscountMapping", false)
                    setRoleOpen(false);
                    setMultipleRole([]);
                    setOpenCustomer(false);
                    setMultipleCustomer([]);
                } else {
                    dispatch(getDiscountAppliesTo({ storeId: config?.storeId, url: '/customers/group', data })).unwrap().then((rawRes: any) => {
                        if (rawRes && rawRes?.customergroup?.rows) {
                            const customerGrpDropdownValues = rawRes?.customergroup?.rows?.map((e: CustomerGroupVal) => ({ label: e?.groupName, value: e?.id }));
                            setCustomerGroup(customerGrpDropdownValues)
                            if (formik?.values?.customerGroupDiscountMapping?.length > 0) {
                                const selectedGrpVal = customerGrpDropdownValues?.filter((e: DropDownData) => formik?.values?.customerGroupDiscountMapping?.includes(e?.value))
                                setMultipleCustomerGroup(selectedGrpVal.map((e: DropDownData) => e?.label))
                            }
                            formik?.setFieldTouched("roleDiscountMapping", false)
                            formik?.setFieldTouched("customerDiscountMapping", false)
                            setRoleOpen(false);
                            setMultipleRole([]);
                            setOpenCustomer(false);
                            setMultipleCustomer([]);
                        }
                    }).catch((err) => {
                        console.log("Error in get customer group", err);
                    })
                }
            }
            if (customerEligibility?.find((e: dropDownValues) => e?.id === formik?.values?.customerEligibilityType)?.code == "ROLE_BASED") {
                if (roleData?.value) {
                    const customerTypeDropdownValues = roleData?.value?.map((e: RoleBasedVal) => ({ label: e?.name, value: e?.id }));
                    setRole(customerTypeDropdownValues)
                    if (formik?.values?.roleDiscountMapping?.length > 0) {
                        const selectedVal = customerTypeDropdownValues.filter((e: DropDownData) => formik?.values?.roleDiscountMapping.includes(e?.value))
                        setMultipleRole(selectedVal.map((e: DropDownData) => e?.label))
                    }
                    formik?.setFieldTouched("customerGroupDiscountMapping", false)
                    formik?.setFieldTouched("customerDiscountMapping", false)
                    setCustomerGroupOpen(false);
                    setOpenCustomer(false)
                    setMultipleCustomer([]);
                    setMultipleCustomerGroup([]);
                } else {
                    dispatch(getDiscountAppliesTo({ storeId: config?.storeId, url: '/roles', data: { isDiscount: true, isActive: true, issueCard: true } })).unwrap().then((rawRes: any) => {
                        if (rawRes && rawRes?.roles?.rows) {
                            const customerTypeDropdownValues = rawRes?.roles?.rows?.map((e: RoleBasedVal) => ({ label: e?.name, value: e?.id }));
                            setRole(customerTypeDropdownValues)
                            if (formik?.values?.roleDiscountMapping?.length > 0) {
                                const selectedVal = customerTypeDropdownValues.filter((e: DropDownData) => formik?.values?.roleDiscountMapping.includes(e?.value))
                                setMultipleRole(selectedVal.map((e: DropDownData) => e?.label))
                            }
                            formik?.setFieldTouched("customerGroupDiscountMapping", false)
                            formik?.setFieldTouched("customerDiscountMapping", false)
                            setCustomerGroupOpen(false);
                            setOpenCustomer(false)
                            setMultipleCustomer([]);
                            setMultipleCustomerGroup([]);
                        }
                    }).catch((err) => {
                        console.log("Error in get roles", err);
                    })
                }
            }
        }
    }, [formik?.values?.customerEligibilityType])

    //function used to handle confirmation popover
    const confirmation = (item: { id: number }) => {
        if (item?.id == 2) {
            setDirtyPopover(false)
            navigation.goBack()
        } else {
            setDirtyPopover(false)
        }
    }


    //UseEffect which gets triggered when discount title value changes
    useEffect(() => {
        if (formik?.values?.discountTitle != '' && !params?.discountId) {
            const duplicateDebounceFunction = setTimeout(() => {
                checkDuplicate(formik?.values?.discountTitle)
            }, 1000)
            return () => clearTimeout(duplicateDebounceFunction)
        }
    }, [formik?.values?.discountTitle])

    //function used to check duplication of discount title
    const checkDuplicate = async (name: string) => {
        let payload = {
            storeId: config?.storeId,
            data: { title: name }
        }
        await dispatch(checkDuplicatesData(payload)).unwrap().then((duplicateResponse) => {
            if (duplicateResponse) {
                setAlreadyExist(duplicateResponse?.exist?.alreadyExist)
            }
        })
    }

    //function used to add/update discount details
    const saveDiscount = async (values: formValues) => {
        if (!formik.dirty) {
            ZenToast({ type: "warning", message: "There is no changes to save" })
            return
        }
        setLoad(true);
        const data = {
            isChangeEligibility: params?.discountId ? (getOnePosDiscountState?.value?.discount?.discountMappings?.customerDiscountMappings != values?.customerDiscountMapping || getOnePosDiscountState?.value?.discount?.discountMappings?.customerGroupDiscountMappings != values?.customerGroupDiscountMapping || getOnePosDiscountState?.value?.discount?.discountMappings?.roleDiscountMappings != values?.roleDiscountMapping) ? true : false : customerEligibility?.find((e: dropDownValues) => e?.value == values?.customerEligibilityType)?.label != 'For All' ? true : false,
            storeId: config?.storeId,
            isManual: false,
            isDeleted: false,
            // isHidden: values?.isHidden,
            isFreeProductChange: true,
            isPayXGetFree: true,
            title: values?.discountTitle,
            minValue: values?.purchaseAmount ? Number(values?.purchaseAmount) : null,
            overallUsageLimit: values?.usagelimits ? Number(values?.usagelimits) : null,
            userBasedMaxUse: values?.usagelimitpercustomer ? Number(values?.usagelimitpercustomer) : null,
            startDate: values?.startDate ? moment(values?.startDate) : moment(),
            endDate: values?.endDate ? moment(values?.endDate) : null,
            isActive: values?.isActive,
            description: values?.desc ? values?.desc : null,
            customerEligibilityType: values?.customerEligibilityType,
            customerGroupDiscountMapping: values?.customerGroupDiscountMapping?.length > 0 ? values?.customerGroupDiscountMapping : null,
            customerDiscountMapping: values?.customerDiscountMapping?.length > 0 ? values?.customerDiscountMapping : null,
            roleDiscountMapping: values?.roleDiscountMapping?.length > 0 ? values?.roleDiscountMapping : null,
            productDiscountMapping: multipleFreeProducts,
            userId: currentUser?.id,
            isPos: true,
            isWeb: false,
            medium: 'POS',
            freeFrom: 1
        }

        if (params?.discountId) {
            try {
                const res = await dispatch(updatePayXDiscount({ storeId: config?.storeId, data, id: params?.discountId })).unwrap()
                if (res) {
                    ZenToast({ type: 'success', message: 'Pay X Get Free discount updated successfully' })
                    navigation.goBack()
                }
            } catch (err) {
                console.log("Error in update PayXDiscount", err)
            } finally {
                setLoad(false);
            }
        } else {
            try {
                const res = await dispatch(addPayXDiscount({ storeId: config?.storeId, data })).unwrap()
                if (res) {
                    ZenToast({ type: 'success', message: 'Pay X Get Free discount added successfully' })
                    navigation.goBack()
                }
            } catch (err) {
                console.log("Error in add PayXDiscount", err)
            } finally {
                setLoad(false);
            }
        }
    }

    //function used to get single discount details
    const getPayXGetFreeDiscountDetails = async () => {
        let res = getOnePosDiscountState?.value;
        if (!res || res?.discount?.discountId != params?.discountId) {
            try {
                res = await dispatch(getOnePayxDiscount({ storeId: config?.storeId, id: params?.discountId })).unwrap();
            } catch (err) {
                console.log("Error in get one discount", err);
            }
        }

        if (res) {
            setMultipleFreeProducts(res?.discount?.discountMappings?.productDiscountMappings)
            if (res?.discount?.endDate != null) {
                if (moment(res?.discount?.endDate).endOf('day').toDate() < moment(new Date()).endOf('day').toDate()) {
                    setDiscountExpired(true)
                }
            }
            await getAllProperties().then(async () => {
                await getFreeProductsData(res?.discount)
            })
            formik.setFieldValue("roleDiscountMapping", res?.discount?.discountMappings?.roleDiscountMappings || [])
            formik.setFieldValue("customerDiscountMapping", res?.discount?.discountMappings?.customerDiscountMappings || [])
            formik.setFieldValue("customerGroupDiscountMapping", res?.discount?.discountMappings?.customerGroupDiscountMappings || [])
            formik.setFieldValue("customerEligibilityType", res?.discount?.customerEligibilityType)
        }
    }

    //function used to fetch products
    const getFreeProductsData = async (values?: DiscountDetails, forceFetch: boolean = false) => {
        let res: any = productData?.value;
        if (!res || forceFetch) {
            try {
                const productResponse: any = await dispatch(getDiscountAppliesTo({ storeId: config?.storeId, url: '/products/name', data: { isDiscount: true } })).unwrap();
                res = productResponse?.products?.rows;
            } catch (err) {
                console.log('Error in getProducts', err)
            }
        }

        const productValues = res?.map((e: { variantId: number | string, name: string }) => ({ label: e?.name, value: e?.variantId }));
        setFreeProducts(productValues);
        if (res && !forceFetch) {
            let tempArr: string[] = []
            if (values) {
                res?.map((i: { variantId: number | string, name: string }) => {
                    if (values?.discountMappings?.productDiscountMappings?.find((e: number) => e == i?.variantId)) {
                        tempArr.push(i?.name)
                    }
                })
                if (values?.discountMappings?.productDiscountMappings && tempArr?.length == 0) {
                    setNoProducts(true);
                    setMultipleFreeProducts([])
                } else {
                    setNoProducts(false)
                }
            }
            setSelectedProductMapping(tempArr)
        }
        setLoad(false)
    }

    //function used to get property values
    const getAllProperties = async () => {
        const propertValues: string[] = ["RECCURRENCE", "APPLICABLE_CUSTOMERS", "APPLICABLE_ITEMS", "APPLICABLE_TO", "DISCOUNT_RESTRICTION_VALUES", "DISCOUNT_CONDITIONAL_TYPE"]
        let res = getAllPropertiesState?.value;
        if (!res) {
            try {
                res = await dispatch(getAllPayxPropertyData({ storeId: config?.storeId, propertyValues: propertValues })).unwrap();
            } catch (err) {
                console.log('Error in getAllProperties', err)
            }
        }

        if (res) {
            let applicableCustomerArr: dropDownValues[] = []
            res?.propertyValueData?.map((item: PropertyValueData) => {
                if (item?.code == "APPLICABLE_CUSTOMERS") {
                    item?.propertyValues?.map((i: PropertyValues) => {
                        applicableCustomerArr.push({ id: i?.id, label: i?.value === "Customer Type" ? "Roles" : i?.value, value: i?.id, code: i?.code })
                    })
                    setCustomerEligibility(applicableCustomerArr)
                }
            })
        }
        if (!params?.discountId) {
            await getFreeProductsData();
        }
        setLoad(false)
    }

    //method to perform the onConfirm functionality
    const onDateConfirm = (date: Date) => {
        if (startDateSelected) {
            formik.setFieldValue('startDate', moment(date))
        }
        else {
            formik?.setFieldValue('endDate', moment(date))
            setDiscountExpired(false);
        }
        setShowDate(false)
    }
    return (
        <KeyboardAvoidingView behavior={Platform.OS === 'ios' ? 'padding' : undefined} enabled style={PayXGetFreeStyle.container}>
            <CommonHeader headerName={params?.discountId ? `${isWrite ? "Edit" : "View"} Pay X Get Free Discount` : "Add Pay X Get Free Discount"} backIcon backIconOnpress={() => { formik?.dirty ? setDirtyPopover(true) : navigation?.goBack() }} />
            {load ? <View style={PayXGetFreeStyle.loader}>
                <ZenLoader viewStyle={{ backgroundColor: "transparent" }} color={appColors?.primary} lottieType="Local" lottie={require('../../../assets/infinityLoader.json')} />
            </View> : <View style={{ flex: 1 }}>
                <View style={addEditBuyXgetYDiscountStyle.buttonView}>

                    {isWrite && <ZenButton
                        title={params?.discountId ? "Update" : 'Save'}
                        onPress={() => formik?.handleSubmit()}
                        buttonStyle={[addEditBuyXgetYDiscountStyle.saveBtnStyle, { backgroundColor: appColors?.primary, borderWidth: 1 }]}
                        titleStyle={addEditBuyXgetYDiscountStyle.saveBtnTextStyle} containerStyle={addEditBuyXgetYDiscountStyle.buttonContainer}
                    />}
                </View>
                <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={{ marginTop: 10 }}>
                    <View style={{ backgroundColor: appColors?.light, borderRadius: 16, padding: 15, marginHorizontal: 15 }}>
                        <ZenText content='Basic Info' color={appColors.primary} bold={true} style={[{ fontSize: fontSize?.largerFontSize }]} />
                        <View style={{ flexDirection: width > 600 ? 'row' : 'column', flex: 1, marginTop: 10, gap: 15 }}>
                            <View style={PayXGetFreeStyle.inputFlex}>
                                <ZenInput
                                    type="outlined"
                                    editable={!discountExpired}
                                    label={'Discount Title *'}
                                    onChangeText={(text: string) => { formik.setFieldValue('discountTitle', text) }}
                                    disabled={params?.discountId || !isWrite ? true : false}
                                    value={formik?.values?.discountTitle}
                                    inputContainerStyle={{ paddingHorizontal: 8 }}
                                    disabledInputStyle={PayXGetFreeStyle.disableStyle}
                                    labelStyle={PayXGetFreeStyle.labelStyle}
                                    errorStyle={PayXGetFreeStyle.errorStyle}
                                    onBlur={() => { formik?.setFieldTouched('discountTitle', true); formik?.setFieldValue('discountTitle', formik?.values?.discountTitle.trim()) }}
                                    errorMessage={formik?.touched?.discountTitle && formik?.errors?.discountTitle ? formik?.errors?.discountTitle : alreadyExist ? 'Discount title already exists.' : undefined} />
                            </View>
                            <View style={PayXGetFreeStyle.inputFlex}>
                                <ZenInput
                                    type="outlined"
                                    inputContainerStyle={{ paddingHorizontal: 8 }}
                                    label='Description'
                                    editable={!discountExpired}
                                    disabled={discountExpired || !isWrite ? true : false}
                                    disabledInputStyle={PayXGetFreeStyle.disableStyle}
                                    onChangeText={(text: string) => formik.setFieldValue('desc', text)}
                                    onBlur={() => { formik?.setFieldValue('desc', formik?.values?.desc) }}
                                    value={formik?.values?.desc}
                                    labelStyle={PayXGetFreeStyle.labelStyle}
                                    errorStyle={PayXGetFreeStyle.errorStyle}
                                    errorMessage={formik?.touched?.desc && formik?.errors?.desc ? formik?.touched?.desc && formik?.errors?.desc : undefined} />
                            </View>
                        </View>

                        <View style={{ flexDirection: width > 600 ? 'row' : 'column', flex: 1, gap: 15 }}>
                            {/* Choose Free Product */}
                            <View style={PayXGetFreeStyle.inputFlex}>
                                <ZenDropdown
                                    title='Choose Free Product *'
                                    placeholder="Select Free Product"
                                    titleStyle={{ color: appColors.labelColor, fontSize: fontSize.smallerFontSize }}
                                    disabled={discountExpired || !isWrite ? true : false}
                                    open={dropdownOpen}
                                    searchable={true}
                                    searchPlaceholder="Search Product"
                                    setOpen={setDropdownOpen}
                                    items={freeProducts}
                                    value={multipleFreeProducts}
                                    dropdownDirection="TOP"
                                    labelStyle={{ fontSize: fontSize?.smallerFontSize, color: appColors?.dark, fontFamily: appFonts?.medium }}
                                    listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize }}
                                    multipleText={formik?.values?.productMapping && formik?.values?.productMapping?.length > 2 ? formik?.values?.productMapping?.slice(0, 2).concat('....').toString() : formik?.values?.productMapping?.toString()}
                                    onSelectItem={(item) => {
                                        formik.setFieldTouched('productMapping', true, false);
                                        formik.setFieldValue('productMapping', item.map((e: { label: string }) => e.label), true);
                                    }}
                                    onPress={() => { formik?.setFieldTouched('productMapping', true) }}
                                    maxHeight={130}
                                    style={{ height: 45 }}
                                    dropDownContainerStyle={PayXGetFreeStyle.borderColor}
                                    multiple={true}
                                    setValue={(val: any) => setMultipleFreeProducts(val)} />
                                {formik?.touched?.productMapping && formik?.values?.productMapping?.length == 0 ? <ZenText content="Please choose a product" color={appColors.red} style={{ fontFamily: appFonts.medium, fontSize: fontSize?.errorFontSize }} /> : null}
                            </View>
                        </View>
                        <View style={{ flexDirection: "row", flex: 1, gap: 25, marginTop: 15, alignItems: "center", }}>
                            <ZenCheckBox
                                title={'Enable'}
                                checked={formik?.values?.isActive}
                                disabled={discountExpired || !isWrite ? true : false}
                                size={22}
                                containerStyle={{ alignSelf: "center" }}
                                titleStyle={theme?.manualDiscountStyle?.checkBoxText}
                                checkedColor={appColors.primary}
                                onPress={() => { formik?.setFieldValue('isActive', !formik?.values?.isActive) }}
                            />
                            {/* <ZenCheckBox
                                title={'Hide from store'}
                                checked={formik?.values?.isHidden!}
                                disabled={discountExpired || !isWrite ? true : false}
                                size={22}
                                containerStyle={{ alignSelf: "center" }}
                                titleStyle={theme?.manualDiscountStyle?.checkBoxText}
                                checkedColor={appColors.primary}
                                onPress={() => { formik?.setFieldValue('isHidden', !formik?.values?.isHidden) }}
                            /> */}
                        </View>
                    </View>
                    <View style={{ backgroundColor: appColors?.light, borderRadius: 16, padding: 18, marginHorizontal: 20, marginTop: 10 }}>
                        <ZenText content='Discount Restriction' bold={true} color={appColors.primary} style={[{ fontSize: fontSize?.largerFontSize }]} />
                        <View style={{ flex: 1, flexDirection: width > 600 ? 'row' : 'column', marginTop: 10, gap: 15 }}>
                            <View style={PayXGetFreeStyle.inputFlex}>
                                <ZenInput
                                    type="outlined"
                                    editable={!discountExpired}
                                    inputContainerStyle={{ paddingHorizontal: 8 }}
                                    disabled={discountExpired || !isWrite ? true : false}
                                    disabledInputStyle={PayXGetFreeStyle.disableStyle}
                                    label='Total Usage limits'
                                    onChangeText={(text: string) => formik.setFieldValue('usagelimits', text)}
                                    value={String(formik?.values?.usagelimits)}
                                    onBlur={() => { formik?.setFieldTouched('usagelimits', true); formik?.setFieldValue('usagelimits', formik?.values?.usagelimits) }}
                                    labelStyle={PayXGetFreeStyle.labelStyle}
                                    errorMessage={formik?.touched?.usagelimits && formik?.errors?.usagelimits ? formik?.touched?.usagelimits && formik?.errors?.usagelimits : undefined}
                                    errorStyle={PayXGetFreeStyle.errorStyle}
                                    rightIcon={
                                        <ZenToolTip
                                            content={<ZenText content="Number of times the discount is to be used" size={fontSize?.badgeFontSize} color={appColors?.dark} />}
                                            height={70}
                                            popover={<Pressable>
                                                <ZenIcon name="exclamationcircle" type="antdesign" size={16} color={appColors?.primary} style={{ marginLeft: 5 }} />
                                            </Pressable>}
                                            width={300}
                                            backgroundColor={appColors?.lightBackgroundColor}
                                            popoverStyle={{ elevation: 4, bottom: 10 }}
                                        />
                                    } />
                            </View>
                            <View style={PayXGetFreeStyle.inputFlex}>
                                <ZenInput
                                    type="outlined"
                                    editable={!discountExpired}
                                    inputContainerStyle={{ paddingHorizontal: 8 }}
                                    disabled={discountExpired || !isWrite ? true : false}
                                    label='Usage limits per customer'
                                    disabledInputStyle={PayXGetFreeStyle.disableStyle}
                                    keyboardType="numeric"
                                    onChangeText={(text: string) => formik.setFieldValue('usagelimitpercustomer', text)}
                                    value={String(formik?.values?.usagelimitpercustomer)}
                                    onBlur={() => { formik?.setFieldTouched('usagelimitpercustomer', true); formik?.setFieldValue('usagelimitpercustomer', formik?.values?.usagelimitpercustomer) }}
                                    labelStyle={PayXGetFreeStyle.labelStyle}
                                    errorMessage={formik?.touched?.usagelimitpercustomer && formik?.errors?.usagelimitpercustomer ? formik?.errors?.usagelimitpercustomer : undefined}
                                    errorStyle={PayXGetFreeStyle.errorStyle} />
                            </View>
                        </View>
                        <View style={{ flex: 1, flexDirection: width > 600 ? 'row' : 'column', marginTop: 10, }}>
                            <ZenInput
                                type="outlined"
                                editable={!discountExpired}
                                inputContainerStyle={{ paddingHorizontal: 8 }}
                                disabled={discountExpired || !isWrite ? true : false}
                                disabledInputStyle={PayXGetFreeStyle.disableStyle}
                                label='Purchase Amount *'
                                keyboardType="numeric"
                                onChangeText={(text: string) => formik.setFieldValue('purchaseAmount', text)}
                                value={formik?.values?.purchaseAmount}
                                onBlur={() => { formik?.setFieldTouched('purchaseAmount', true); formik?.setFieldValue('purchaseAmount', formik?.values?.purchaseAmount?.trim()) }}
                                labelStyle={PayXGetFreeStyle.labelStyle}
                                errorMessage={formik?.touched?.purchaseAmount && formik?.errors?.purchaseAmount ? formik?.touched?.purchaseAmount && formik?.errors?.purchaseAmount : undefined}
                                errorStyle={PayXGetFreeStyle.errorStyle} />
                        </View>
                    </View>
                    <View style={{ backgroundColor: appColors?.light, borderRadius: 16, padding: 18, marginHorizontal: 20, marginTop: 10 }}>
                        <ZenText content='Schedule' bold={true} color={appColors.primary} style={[{ fontSize: fontSize?.largerFontSize }]} />
                        <View style={{ flex: 1, flexDirection: 'row', marginTop: 10, gap: 15 }}>
                            <Pressable style={PayXGetFreeStyle.inputFlex} onPress={() => {
                                if (formik?.values?.startDate != '' && (moment(formik?.values?.startDate).endOf('day').toDate() > moment(new Date()).endOf('day').toDate())) {
                                    setDate(new Date(formik?.values?.startDate))
                                }
                                else {
                                    setDate(new Date());
                                    formik.setFieldTouched('startDate', true);
                                }
                                setStartDateSelected(true)
                                setShowDate(!showDate);
                            }} >
                                <ZenInput
                                    type="outlined"
                                    label='Start date'
                                    editable={false}
                                    placeholder='MM/DD/YYYY'
                                    inputContainerStyle={{ paddingHorizontal: 8 }}
                                    onChangeText={(text: string) => formik.setFieldValue('startDate', text)}
                                    value={formik?.values?.startDate != '' ? moment(new Date(formik?.values?.startDate))?.format('MM/DD/YYYY')?.toString() : ""}
                                    labelStyle={PayXGetFreeStyle.labelStyle}
                                    errorStyle={PayXGetFreeStyle.errorStyle}
                                    rightIcon={<ZenIcon name="calendar" type='material-community' size={20} color={appColors.grey}
                                    />}
                                    errorMessage={formik.touched.startDate && formik.errors.startDate ? formik.errors.startDate as string : ""}
                                />
                            </Pressable>
                            <Pressable style={PayXGetFreeStyle.inputFlex} onPress={() => {
                                if (formik?.values?.endDate != '' && (moment(formik?.values?.endDate).endOf('day').toDate() > moment(new Date()).endOf('day').toDate())) {
                                    setDate(new Date(formik?.values?.endDate))
                                }
                                else {
                                    setDate(new Date())
                                }
                                formik.setFieldTouched('endDate', true)
                                setStartDateSelected(false)
                                setShowDate(!showDate)
                            }} >
                                <ZenInput
                                    type="outlined"
                                    editable={false}
                                    label='End date'
                                    placeholder='MM/DD/YYYY'
                                    inputContainerStyle={{ paddingHorizontal: 8 }}
                                    onChangeText={(text) => formik.setFieldValue('endDate', text)}
                                    value={formik?.values?.endDate != '' ? moment(new Date(formik?.values?.endDate))?.format('MM/DD/YYYY')?.toString() : ""}
                                    labelStyle={PayXGetFreeStyle.labelStyle}
                                    errorStyle={PayXGetFreeStyle.errorStyle}
                                    rightIcon={<ZenIcon name="calendar" size={20} type='material-community' color={appColors.grey}
                                    />}
                                    errorMessage={formik.touched.endDate && formik.errors.endDate ? formik.errors.endDate as string : ""}
                                />
                            </Pressable>
                            {showDate && <ZenDateTimePicker
                                date={date}
                                mode='date'
                                open={showDate}
                                minimumDate={startDateSelected ? new Date(moment().format("YYYY-MM-DD")) : (formik.values?.startDate ? new Date(formik.values?.startDate) : new Date(moment().format("YYYY-MM-DD")))}
                                maximumDate={startDateSelected && formik?.values?.endDate ? new Date(formik?.values?.endDate) : undefined}
                                onConfirm={(val: any) => { onDateConfirm(val) }}
                                onCancel={() => { setShowDate(false) }}
                            />}
                        </View>
                    </View>
                    <View style={{ backgroundColor: appColors?.light, borderRadius: 16, padding: 18, marginHorizontal: 20, marginTop: 10, marginBottom: 25 }}>
                        <ZenText content='Customer Eligibility' bold={true} color={appColors.primary} style={[{ fontSize: fontSize?.largerFontSize }]} />
                        <View style={{ flex: 1, flexDirection: 'row', gap: 15 }}>
                            <View style={{ marginTop: 10, flex: 0.5 }}>
                                <ZenDropdown
                                    title="Customer Eligibility Type *"
                                    titleStyle={{ color: appColors.labelColor, fontSize: fontSize.smallerFontSize }}
                                    disabled={discountExpired || !isWrite ? true : false}
                                    items={customerEligibility}
                                    open={eligibilityOpen}
                                    setOpen={setEligibilityOpen}
                                    onSelectItem={(item: any) => {
                                        formik.setFieldTouched('customerEligibilityType', true, false);
                                        if (customerEligibility?.find((i: { id: number }) => i?.id === item?.id)?.code == customerEligibilityTypeObj?.ForAll) {
                                            formik.setFieldTouched('roleDiscountMapping', false, false);
                                            formik.setFieldTouched('customerDiscountMapping', false, false);
                                            formik.setFieldTouched('customerGroupDiscountMapping', false, false);
                                            setMultipleRole([]); setMultipleCustomer([]); setMultipleCustomerGroup([]);
                                            formik.setValues({
                                                ...formik.values,
                                                customerEligibilityType: item?.value,
                                                roleDiscountMapping: [],
                                                customerDiscountMapping: [],
                                                customerGroupDiscountMapping: []
                                            }, true);
                                        } else {
                                            formik?.setFieldValue('customerEligibilityType', item?.value, true)
                                        }
                                    }}
                                    labelStyle={{ fontSize: fontSize?.smallerFontSize, color: appColors?.dark, fontFamily: appFonts?.medium }}
                                    listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize }}
                                    disabledStyle={{ opacity: 0.5 }}
                                    dropdownDirection="TOP"
                                    value={formik?.values?.customerEligibilityType}
                                    maxHeight={120}
                                    style={[PayXGetFreeStyle.borderColor, { height: 45 }]}
                                    dropDownContainerStyle={PayXGetFreeStyle.borderColor}
                                    multiple={false}
                                    setValue={() => { }} />
                            </View>
                            {customerEligibility?.find((ele: dropDownValues) => ele?.id === formik?.values?.customerEligibilityType)?.code === customerEligibilityTypeObj?.CustomerGroup &&
                                <View style={PayXGetFreeStyle.dropView}>
                                    <ZenDropdown
                                        title="Choose Customer Group *"
                                        placeholder="Select Customer Group"
                                        titleStyle={{ color: appColors.labelColor, fontSize: fontSize.smallerFontSize }}
                                        disabled={discountExpired || !isWrite ? true : false}
                                        multiple={true}
                                        searchable={true}
                                        searchPlaceholder="Search Customer Group"
                                        items={customerGroup}
                                        open={customerGroupOpen}
                                        dropdownDirection="TOP"
                                        setOpen={setCustomerGroupOpen}
                                        multipleText={multipleCustomerGroup?.length > (width > 600 ? 7 : 22) ? multipleCustomerGroup.slice(0, width > 600 ? 7 : 22).concat('...').toString() : multipleCustomerGroup.toString()}
                                        onSelectItem={(item) => {
                                            setMultipleCustomerGroup(item.map((e) => e.label));
                                            formik.setFieldTouched('customerGroupDiscountMapping', true, false);
                                            setMultipleCustomer([]); setMultipleRole([])
                                            formik.setValues({
                                                ...formik.values,
                                                customerGroupDiscountMapping: item.map((e) => e?.value),
                                                customerDiscountMapping: [],
                                                roleDiscountMapping: []
                                            }, true);
                                        }}
                                        labelStyle={{ fontSize: fontSize?.smallerFontSize, color: appColors?.dark, fontFamily: appFonts?.medium }}
                                        listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize }}
                                        disabledStyle={{ opacity: 0.5 }}
                                        onPress={() => { formik?.setFieldTouched('customerGroupDiscountMapping', true, false) }}
                                        value={formik?.values?.customerGroupDiscountMapping}
                                        setValue={() => { }}
                                        maxHeight={140}
                                        style={[PayXGetFreeStyle.borderColor, { height: 45 }]}
                                        dropDownContainerStyle={PayXGetFreeStyle.borderColor}
                                    />
                                    {formik?.touched?.customerGroupDiscountMapping && formik?.errors?.customerGroupDiscountMapping && <ZenText style={{ color: appColors.red, marginLeft: 10, fontSize: width > 900 ? 15 : width > 600 ? 13 : 12, fontFamily: appFonts.medium }} content={formik?.errors?.customerGroupDiscountMapping.toString()} />}
                                </View>}
                            {customerEligibility?.find((ele: dropDownValues) => ele?.id === formik?.values?.customerEligibilityType)?.code === customerEligibilityTypeObj?.RoleBased &&
                                <View style={PayXGetFreeStyle.dropView}>
                                    <ZenDropdown
                                        title="Choose Role *"
                                        placeholder="Select Role"
                                        titleStyle={{ color: appColors.labelColor, fontSize: fontSize.smallerFontSize }}
                                        disabled={discountExpired || !isWrite ? true : false}
                                        multiple={true}
                                        searchPlaceholder="Search Role"
                                        dropdownDirection="TOP"
                                        items={role}
                                        open={roleOpen}
                                        setOpen={setRoleOpen}
                                        multipleText={multipleRole?.length > (width > 600 ? 7 : 22) ? multipleRole?.slice(0, width > 600 ? 7 : 22).concat('...').toString() : multipleRole.toString()}
                                        onSelectItem={(item) => {
                                            setMultipleRole(item.map((e) => e?.label));
                                            formik.setFieldTouched('roleDiscountMapping', true, false);
                                            setMultipleCustomer([]); setMultipleCustomerGroup([])
                                            formik.setValues({
                                                ...formik.values,
                                                roleDiscountMapping: item.map((e) => e.value),
                                                customerGroupDiscountMapping: [],
                                                customerDiscountMapping: []
                                            }, true);
                                        }}
                                        labelStyle={{ fontSize: fontSize?.smallerFontSize, color: appColors?.dark, fontFamily: appFonts?.medium }}
                                        listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize }}
                                        onPress={() => { formik?.setFieldTouched('roleDiscountMapping', true, false) }}
                                        value={formik?.values?.roleDiscountMapping}
                                        setValue={() => { }}
                                        maxHeight={140}
                                        disabledStyle={{ opacity: 0.5 }}
                                        style={[PayXGetFreeStyle.borderColor, { height: 45 }]}
                                        dropDownContainerStyle={PayXGetFreeStyle.borderColor}
                                        searchable={true}
                                    />
                                    {formik?.touched?.roleDiscountMapping && formik?.errors?.roleDiscountMapping &&
                                        <ZenText style={{ color: appColors.red, marginLeft: 10, fontSize: width > 900 ? 15 : width > 600 ? 13 : 12, fontFamily: appFonts.medium }} content={formik?.errors?.roleDiscountMapping.toString()} />
                                    }
                                </View>}
                            {customerEligibility?.find((ele: dropDownValues) => ele?.id === formik?.values?.customerEligibilityType)?.code === customerEligibilityTypeObj?.Customers &&
                                <View style={PayXGetFreeStyle.dropView}>
                                    <ZenDropdown
                                        title="Choose Customers *"
                                        placeholder="Select Customer"
                                        titleStyle={{ color: appColors.labelColor, fontSize: fontSize.smallerFontSize }}
                                        disabled={discountExpired || !isWrite ? true : false}
                                        multiple={true}
                                        items={customer}
                                        open={openCustomer}
                                        setOpen={setOpenCustomer}
                                        dropdownDirection="TOP"
                                        labelStyle={{ fontSize: fontSize?.smallerFontSize, color: appColors?.dark, fontFamily: appFonts?.medium }}
                                        listItemLabelStyle={{ fontSize: fontSize?.smallerFontSize }}
                                        multipleText={multipleCustomer?.length > (width > 600 ? 7 : 22) ? multipleCustomer.slice(0, width > 600 ? 7 : 22).concat('...').toString() : multipleCustomer.toString()}
                                        onSelectItem={(item) => {
                                            setMultipleCustomer(item.map((e) => e.label));
                                            formik.setFieldTouched('customerDiscountMapping', true, false);
                                            setMultipleRole([]); setMultipleCustomerGroup([])
                                            formik.setValues({
                                                ...formik.values,
                                                customerDiscountMapping: item.map((e) => e.value),
                                                customerGroupDiscountMapping: [],
                                                roleDiscountMapping: []
                                            }, true);
                                        }}
                                        onPress={() => { formik?.setFieldTouched('customerDiscountMapping', true, false) }}
                                        value={formik?.values?.customerDiscountMapping}
                                        setValue={() => { }}
                                        maxHeight={140}
                                        disabledStyle={{ opacity: 0.5 }}
                                        style={{ borderColor: appColors?.lightGrey, height: 45 }}
                                        dropDownContainerStyle={PayXGetFreeStyle.borderColor}
                                        searchable={true}
                                        searchPlaceholder="Search Customers"
                                    />
                                    {formik?.touched?.customerDiscountMapping && formik?.errors?.customerDiscountMapping && <ZenText style={{ color: appColors.red, marginLeft: 10, fontSize: width > 900 ? 15 : width > 600 ? 13 : 12, fontFamily: appFonts.medium }} content={String(formik?.errors?.customerDiscountMapping)} />}
                                </View>}
                        </View>
                    </View>
                    <Popover isVisible={dirtyPopover} popoverStyle={{ width: width > 900 ? 600 : width > 600 ? 450 : 350, borderRadius: 10, }}>
                        <CommonDialogBox type='EDIT' replaceValue="page" confirmation={confirmation} />
                    </Popover>
                    <Popover isVisible={showProductPopover} popoverStyle={{ width: width > 900 ? 600 : width > 600 ? 450 : 350, borderRadius: 10, }}>
                        <CommonDialogBox type="OTHER" dialog={dialogProps} confirmation={setConfirmMessage} />
                    </Popover>
                    <Popover isVisible={expiredPopover} popoverStyle={{ width: width > 900 ? 600 : width > 600 ? 450 : 350, borderRadius: 10, }}>
                        <CommonDialogBox type="OTHER" dialog={expiredDialogProps} confirmation={setExpiredMessage} />
                    </Popover>
                </ScrollView>

            </View>}
        </KeyboardAvoidingView>
    )
}
export default AddEditPayXGetFree